// extracted by mini-css-extract-plugin
export default {"switchWrapper":"SwitcherWithText-modules__switchWrapper__IIvI1","switchText":"SwitcherWithText-modules__switchText__yO2M1"};